/* eslint-disable no-unused-vars */
import { makeEntityScaffold } from '@classpass/saga-tools';
import { transformV2ClientResponse } from 'helpers/core';
import URLS from 'constants/urls';
import { VENUE_FEATURE_PROBE_HTTP_CONFIG } from 'helpers/session-auth-http';

// Filtering invalid data which is being returned with field name set to an empty string
const filterOutObjectsWithEmptyNames = data => data.filter(({ name }) => /\S/.test(name));

// A 401/403 here means this venue/user lacks Calendar Sync access, not an expired
// session — surface it via the in-flow error UI instead of redirecting to login.
const handler = ({ httpClient }, venueId) => {
  const endpoint = URLS.instructorCalendars.list(venueId);

  return httpClient
    .get(endpoint, VENUE_FEATURE_PROBE_HTTP_CONFIG)
    .then(transformV2ClientResponse)
    .then(data => {
      return {
        practitioners: data?.staffAndEquipment ?? [],
        venueCalendarExport: data?.venueCalendarExport ?? {},
      };
    })
    .then(data => ({
      ...data,
      practitioners: filterOutObjectsWithEmptyNames(data.practitioners),
    }));
};

export default makeEntityScaffold('SAGA.API.TEACHER_CALENDAR', handler, { defaultKey: 1 });
